import Axios from "axios";

const API_URL = process.env.NODE_ENV === 'production'
  ? "https://api.djparafestas.com.br/api/v2"
  : (process.env.REACT_APP_API_URL || "http://localhost:8000/api/v2");

export class HttpService {
  _axios = Axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json'
    },
    withCredentials: true // Permite que o navegador aceite cookies da API
  });

  constructor() {
    this._axios.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    return this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  ejectResponseInterceptor = (id) => {
    this._axios.interceptors.response.eject(id);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));

  post = async (url, data) => await this.request(this.getOptionsConfig("post", url, data));

  put = async (url, data) => await this.request(this.getOptionsConfig("put", url, data));

  patch = async (url, data) => await this.request(this.getOptionsConfig("patch", url, data));

  delete = async (url) => await this.request(this.getOptionsConfig("delete", url));

  getOptionsConfig = (method, url, data) => {
    const options = { method, url, data };
    if (data instanceof FormData) {
      options.headers = { 'Content-Type': 'multipart/form-data' };
    }
    return options;
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => {
          // httpStatus (e não "status", que já existe em vários corpos da API) para quem
          // precisa distinguir, por exemplo, um 404 sem corpo de um 409 com "code".
          if (!ex.response) {
            reject(ex);
            return;
          }
          const data = ex.response.data;
          const body = data && typeof data === "object" ? data : { message: data || ex.message };
          reject({ ...body, httpStatus: ex.response.status });
        });
    });
  }
}

export default new HttpService();
